// extracted by mini-css-extract-plugin
module.exports = {"Loader":"Spinner_Loader__1gsIr","load2":"Spinner_load2__REk3w"};